import * as React from 'react';

/**
 * @description NotificationMegaphone icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { NotificationMegaphone } from '@sravni/design-system-icons'
 *
 * <NotificationMegaphone />
 * ```
 */
const NotificationMegaphone = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "NotificationMegaphone", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "m14.74 2.743-.274.305a15.577 15.577 0 0 1-6.36 4.288c-.503.153-1.713.51-2.229.61l-.8.155a1.95 1.95 0 0 0-1.28.881 2.17 2.17 0 0 0-.295 1.586c.222 1.15 1.29 1.913 2.38 1.702l.807-.156h.001l.032-.007c.504-.096 1.746-.213 2.257-.258a15.563 15.563 0 0 1 7.493 1.6l.37.182-1.06-5.395-1.042-5.493ZM15.584 5.526c1.387.22 2.084 1.01 2.309 2.072.224 1.062-.163 2.118-1.35 2.852", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m8.854 11.776 1.33 3.936c.222.68-.033 1.365-.58 1.562-.548.196-1.2-.163-1.487-.82l-1.903-4.355", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m11.038 11.56.616 1.365c.418.979-.348 2.055-1.75 2.457M7.976 7.151l.88 4.635", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinejoin: "round" }))));

export { NotificationMegaphone };
//# sourceMappingURL=NotificationMegaphone.js.map
